import { render, staticRenderFns } from "./homeSectionTestimonials.vue?vue&type=template&id=70700d8c&scoped=true&"
import script from "./homeSectionTestimonials.vue?vue&type=script&lang=js&"
export * from "./homeSectionTestimonials.vue?vue&type=script&lang=js&"
import style0 from "./homeSectionTestimonials.vue?vue&type=style&index=0&id=70700d8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70700d8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VDivider,VImg,VSheet})
